export default {
  backgroundColor: 'var(--off-white)',
  opacityName: '0.6',
  fontSize: '14px',
  wrapperWidth: 'calc(50% - 0.5rem)',
  imageHeight: '300px',
  mainWidth: '100%',
  textTransform: 'uppercase',
};
